import React from "react";
import DSBox from "../../system-design/DSBox";
import DSTypography from "../../system-design/DSTypography";
import DSGrid from "../../system-design/DSGrid";
import DSAvatar from "../../system-design/DSAvatar";
import DSTooltip from "../../system-design/DSTooltip";
import KlydoLoopUrl from "../../../components/klydoPreview/KlydoLoopUrl";
import { Klydo } from "../../../Types";

type KlydoGridDisplayProps = {
  klydos: Klydo[];
  gridSize?: { xs?: number; sm?: number; md?: number };
  avatarSize?: number;
  showAuthor?: boolean;
  onKlydoClick?: (klydo: Klydo) => void;
};

const KlydoGridDisplay = ({
  klydos,
  gridSize = { xs: 6, sm: 4, md: 3 },
  avatarSize = 50,
  showAuthor = true,
  onKlydoClick,
}: KlydoGridDisplayProps) => {
  return (
    <DSGrid container spacing={1}>
      {klydos.map((klydo) => (
        <DSGrid item {...gridSize} key={klydo.id}>
          <DSBox
            onClick={() => onKlydoClick?.(klydo)}
            sx={{
              p: 1.5,
              border: "1px solid #e0e0e0",
              borderRadius: 1,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1,
              cursor: onKlydoClick ? "pointer" : "default",
              transition: "all 0.2s",
              "&:hover": onKlydoClick
                ? {
                    boxShadow: 2,
                    transform: "translateY(-2px)",
                    borderColor: "#90caf9",
                  }
                : {},
            }}
          >
            <DSBox
              sx={{
                width: avatarSize,
                height: avatarSize,
                overflow: "hidden",
                borderRadius: "50%",
              }}
            >
              {klydo.loopUrl ? (
                <KlydoLoopUrl loopUrl={klydo.loopUrl} />
              ) : (
                <DSAvatar
                  src={klydo.klydoSecureUrl || undefined}
                  sx={{
                    width: "100%",
                    height: "100%",
                  }}
                >
                  {klydo.name.charAt(0)}
                </DSAvatar>
              )}
            </DSBox>
            <DSTooltip title={klydo.name}>
              <DSTypography
                variant="caption"
                fontWeight="bold"
                textAlign="center"
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "100%",
                }}
              >
                {klydo.name}
              </DSTypography>
            </DSTooltip>
            {showAuthor && (
              <DSTypography
                variant="caption"
                color="text.secondary"
                textAlign="center"
                sx={{ fontSize: "0.65rem" }}
              >
                by {klydo.author?.name || klydo.creator}
              </DSTypography>
            )}
          </DSBox>
        </DSGrid>
      ))}
    </DSGrid>
  );
};

export default KlydoGridDisplay;
